var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "candidate-modal-documents" }, [
    _c("input", {
      ref: "fileUploadInput",
      staticClass: "hidden",
      attrs: { type: "file", multiple: "", accept: _vm.acceptedFileFormats },
      on: { change: _vm.onFileUpload },
    }),
    _c(
      "div",
      { staticClass: "candidate-modal-documents__actions" },
      [
        _vm.noFilesExists
          ? _c("div", { staticClass: "no-files" }, [_vm._v("Файлов пока нет")])
          : _vm._e(),
        !_vm.noFilesExists
          ? _c("c-button", {
              attrs: {
                label: "Скачать одним архивом",
                icon: "download",
                size: "small",
                responsive: true,
              },
              on: { click: _vm.downloadAllDocuments },
            })
          : _vm._e(),
        _c("c-button", {
          attrs: {
            label: "Добавить файл",
            icon: { icon: "plus", color: "primary" },
            size: "small",
            disabled: _vm.disableFileUploadButton,
            responsive: true,
          },
          on: {
            click: function ($event) {
              return _vm.$refs.fileUploadInput.click()
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "candidate-modal-documents__files" },
      [
        _vm.appendedFiles.length
          ? _c(
              "viewer",
              { attrs: { images: _vm.appendedFiles.map((i) => i.url) } },
              _vm._l(_vm.appendedFiles, function (file, fileIndex) {
                return _c("file-template-component", {
                  key: `file-${fileIndex}`,
                  attrs: { file: file, "file-index": fileIndex },
                  on: {
                    "remove-image": function ($event) {
                      return _vm.removeImage(file.name, fileIndex)
                    },
                  },
                })
              }),
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }